import { CARD_H, CARD_W } from "@webscan/constants.js";

export const SHARPEN_WAIT_MS = 200;
interface Quality {
  focus: number;
  score: number;
  aspect: number;
}

/** A slipped quad can score sharper by including the table. Quality must agree. */
export function sharperSample<T extends Quality>(kept: T, next: T, elapsedMs: number): T {
  const aspect = CARD_W / CARD_H;
  return elapsedMs <= SHARPEN_WAIT_MS &&
    next.focus >= kept.focus * 1.15 &&
    next.score >= kept.score &&
    Math.abs(next.aspect - aspect) <= Math.abs(kept.aspect - aspect)
    ? next
    : kept;
}

export const COLLECTOR_RETRY_MS = 300;
export const COLLECTOR_MAX_RETRIES = 6;
